import antdZh from 'antd/lib/locale-provider/zh_CN';
// import appLocaleData from 'react-intl/locale-data/zh';
import zhMessages from '../../locales/zh.json';

const appLocale_zh = {
  messages: {
    ...zhMessages,
  },
  antd: antdZh,
  locale: 'zh-CN',
  // data: appLocaleData,
};

export default appLocale_zh;
